import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	editOption: {
		id: 'polaris-common.common.decoration.select.option.edit-option',
		defaultMessage: 'Edit option',
		description: 'Button to edit the currently open option',
	},
});
